/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorContentLock from 'base/components/labrador/ContentLock';

export const DynamicLabradorContentLock: typeof LabradorContentLock = (props) => {
    return <ErrorBoundary><LabradorContentLock {...props} /></ErrorBoundary>;
}
export type DynamicLabradorContentLockProps = PropsFromComponent<typeof LabradorContentLock>;
